/**
 * useHolders — Fetches top token holders.
 *
 * Story 4.1: Token Detail API hooks
 */

import { useQuery } from "@tanstack/react-query";
import { tokensApi } from "../../lib/api";
import { tokenKeys } from "./query-keys";

export function useHolders(id: string, limit?: number) {
	return useQuery({
		queryKey: tokenKeys.holders(id),
		queryFn: async () => {
			const response = await tokensApi.getHolders(id, limit);
			return response.data;
		},
		enabled: !!id,
		staleTime: 60_000,
	});
}
